<template>
  <div class="Header">
    <div class="row Shadow">
      <div class="container">
        <div class="row start-sm center-xs">
          <div class="col-xs-12 col-sm-5">
            <img class="Header__BrandImage" :src="require('../../assets/images/jhf_logo.svg')" @click="toHome" />
          </div>
          <div class="col-xs-12 col-sm-7 end-sm Header__Navigation">
            <el-button class="lang-btn Header__Navigation Header__Navitem" v-if="$store.state.general.language === 'english'" @click.native="language('japanese')">
                日本語
            </el-button>
            <el-button class="lang-btn Header__Navigation Header__Navitem" v-if="$store.state.general.language === 'japanese'" @click.native="language('english')">
                English
            </el-button>

            <router-link to="/help"  class="Header__Navigation Header__Navitem">{{'Help' | language}}</router-link>
            <router-link to="/register" class="Header__Navigation Header__Navitem" v-if="!isLoggedIn">{{'Register' | language}}</router-link>
            <Auth class="Header__Navigation Header__Navitem"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Auth from '../Pages/Auth/Auth'

  export default {
    name: 'app',
    data() {
        return {
            lang: 'english'
        }
    },
    components: {
      Auth
    },
    computed: {
      isLoggedIn() {
        return this.$store.getters['user/isLoggedIn']
      }
    },
    methods: {
      toHome() {
        this.$router.push({
            path: '/',
            query: {}
        })
      },
      language(value) {
        this.$store.commit('general/set_language', value);
      }
    }
  }
</script>

<style lang="scss">
  .Header {
    position: fixed;
    min-width: 100vw;
    background-color: rgb(255, 255, 255);
    padding: 0 10px;
    box-shadow: black 10px;
    z-index: 10000;

    .lang-btn {
        border: none !important;
        color: #3d3d3d !important;

        &:hover, &:focus {
            border: none !important;
            background: transparent !important;
            color: $primary-color !important;

            .fas {
                color: $primary-color;
            }
        }

        .fas {
            font-size: 1.5em;
            vertical-align: middle;
            padding-right: .5em;
            color: rgba($alternate-color, .3);
            transition: .2s ease-in-out;
        }
    }

    &__BrandImage {
      cursor: pointer;
      padding-top: .3rem;
      width: 350px;
      height: auto;
    }

    &__Navigation {
      font-weight: 600;
      padding: 1rem 0;
    }

    &__Navitem {
      text-decoration: none;
      padding-right: 1.5rem;
      color: #3d3d3d;

      &:hover {
        text-decoration: none;
      }

      &:last-child {
        padding-right: 0;

      }
    }

    @media (max-width: 767px) {
      &__BrandImage {
        padding: .5rem 0;
        max-width: 250px;
      }

      .end-sm {
        border-top: 1px solid $alternate-background;
        padding: .5rem;
      }

      .el-dropdown {
        height: 100%;
      }

      .el-button--default {
        border: none !important;
        padding: 0 !important;

        &:hover, &:focus {
          border: none !important;
          color: $primary-color !important;
          background-color: transparent !important;
        }

        &.lang-btn {
            padding-right: 1.5rem !important;
        }
      }
    }
  }

  .Shadow {
    box-shadow: $box-shadow;
  }
</style>
